import React from 'react';
import { motion } from 'framer-motion';
// Các variants animation khác nhau
const pageVariants = {
  initial: {
    opacity: 0,
    x: '-100vw',
    scale: 0.8
  },
  in: {
    opacity: 1,
    x: 0,
    scale: 1
  },
  out: {
    opacity: 0,
    x: '100vw',
    scale: 1.2
  }
};

const fadeVariants = {
  initial: {
    opacity: 0,
    y: 20
  },
  in: {
    opacity: 1,
    y: 0
  },
  out: {
    opacity: 0,
    y: -20
  }
};

const scaleVariants = {
  initial: {
    opacity: 0,
    scale: 0.8,
    rotateX: 90
  },
  in: {
    opacity: 1,
    scale: 1,
    rotateX: 0
  },
  out: {
    opacity: 0,
    scale: 1.2,
    rotateX: -90
  }
};

const pageTransition = {
  type: 'tween',
  ease: 'anticipate',
  duration: 0.4
};

const fastTransition = {
  type: 'tween',
  ease: 'easeInOut',
  duration: 0.3
};

const springTransition = {
  type: 'spring',
  stiffness: 260,
  damping: 20,
  duration: 0.5
};

const AnimatedPage = ({ children, animationType = 'slide' }) => {
  let variants;
  let transition;

  switch (animationType) {
    case 'fade':
      variants = fadeVariants;
      transition = fastTransition;
      break;
    case 'scale':
      variants = scaleVariants;
      transition = springTransition;
      break;
    case 'slide':
    default:
      variants = pageVariants;
      transition = pageTransition;
      break;
  }

  return (
    <motion.div
      initial="initial"
      animate="in"
      exit="out"
      variants={variants}
      transition={transition}
      style={{
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: 0,
        left: 0,        
      }}
    >
      {children}
    </motion.div>
  );
};

export default AnimatedPage;
